export default "__VITE_ASSET__BeqNbB6I__"